import type { FunctionComponent } from "react"

import classNames from "classnames"
import Image from "next/image"

import empoweredByJobteaserBlack from "@/modules/brand/assets/empowered_by_jobteaser-black.svg"
import empoweredByJobteaserWhite from "@/modules/brand/assets/empowered_by_jobteaser-white.svg"

import styles from "./Brand.module.css"

type CCLogoProps = {
  name: string
  logo: string
  secondaryLogo?: string
  from: "footer" | "header"
}

export const CCLogo: FunctionComponent<CCLogoProps> = ({ name, logo, secondaryLogo, from }) => {
  const logoClassname = classNames(styles["app-Brand__CcLogo"], {
    [styles["app-Brand__CcLogo___footer"]]: from === "footer",
  })

  return (
    <div className={logoClassname}>
      <img className={styles["app-Brand__CcImage"]} src={logo} alt={name} />
      {secondaryLogo && <img className={styles["app-Brand__CcImage"]} src={secondaryLogo} alt={name} />}
      <div className={styles["app-Brand__CcTitleGroup"]}>
        <div className={styles["app-Brand__CcTitle"]}>{name}</div>
        <Image
          className={styles["app-Brand__CcSubtitle"]}
          src={from === "header" ? empoweredByJobteaserBlack : empoweredByJobteaserWhite}
          alt="Empowered by JobTeaser"
          height={9}
          width={110}
          priority={from === "header"}
        />
      </div>
    </div>
  )
}
